import { ChangeDetectionStrategy, Component, EventEmitter, Output } from "@angular/core";
import { TranslationService } from "@core-services/translation.service";
import { config } from "@config";

@Component({
	selector: "app-locked-staking-unstake-disclaimer",
	templateUrl: "./locked-staking-unstake-disclaimer.component.html",
	styleUrls: ["./locked-staking-unstake-disclaimer.component.scss"],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false
})
export class LockedStakingUnstakeDisclaimerComponent {
	@Output() onButtonClick = new EventEmitter<void>();
	private link = this.translationService.getHdLink() + config.externalPaths["staking"]["lockedStakingHdLink"];

	constructor(private readonly translationService: TranslationService) {}

	public openLink(): void {
		window.open(this.link, "_blank");
	}
}
